import Vue from "vue";
import Router from "vue-router";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import FarmsProduct from "@/pages/FarmsProduct";
import AirportProduct from "@/pages/AirportProduct";
import AreaProduct from "@/pages/AreaProduct";
import FarmsPresentation from "@/pages/FarmsPresentation";
import AirportPresentation from "@/pages/AirportPresentation";
import AreaPresentation from "@/pages/AreaPresentation";
import AboutUs from "@/pages/AboutUs";
import Awards from "@/pages/Awards";
import Privacy from "@/pages/Privacy";
import Blog from "@/pages/Blog";
import Auctions from "@/pages/Auctions";
import Infonews from "@/pages/Infonews";
import Contact from "@/pages/Contact";
import CofinancedFromEU from "@/pages/CofinancedFromEU";
import BPS from "@/pages/BPS";
import BPS2 from "@/pages/BPS2";
import PBE from "@/pages/PBE";
import PBE2 from "@/pages/PBE2";
import AFMS from "@/pages/AFMS";
import BridgeAlfa from "@/pages/BridgeAlfa";
import PMT from "@/pages/PMT";
import EIC from "@/pages/EIC";
import store from "../store/store";
import PPBB from "@/pages/PPBB";
import Certificates from "@/pages/Certificates";
import Offshore from "@/pages/Offshore.vue";

Vue.use(Router);

import { pl } from "../lang/pl";
import { en } from "../lang/en";

const lang = { pl, en };

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        title: "home"
      },

      props: {
        canvasVisible: true
      }
    },
    {
      path: "/products",
      name: "products",
      component: Products,
      meta: {
        title: "products"
      }
    },
    {
      path: "/products/farms",
      name: "farms",
      component: FarmsProduct,
      meta: {
        title: "farm"
      }
    },
    {
      path: "/products/airport",
      name: "airport",
      component: AirportProduct,
      meta: {
        title: "airport"
      }
    },
    {
      path: "/products/area",
      name: "area",
      component: AreaProduct,
      meta: {
        title: "area"
      }
    },
    {
      path: "/products/farms/presentation",
      name: "farms presentation",
      component: FarmsPresentation,
      props: {
        canvasVisible: true
      },
      meta: {
        title: "farmPresentation"
      }
    },
    {
      path: "/products/airport/presentation",
      name: "airport presentation",
      component: AirportPresentation,
      props: {
        canvasVisible: true
      },
      meta: {
        title: "airportPresentation"
      }
    },
    {
      path: "/products/area/presentation",
      name: "area presentation",
      component: AreaPresentation,
      props: {
        canvasVisible: true
      },
      meta: {
        title: "areaPresentation"
      }
    },
    {
      path: "/about",
      name: "about-us",
      component: AboutUs,
      meta: {
        title: "about"
      }
    },
    {
      path: "/certificates",
      name: "certificates",
      component: Certificates,
      meta: {
        title: "certificates"
      }
    },
    {
      path: "/awards",
      name: "awards",
      component: Awards,
      meta: {
        title: "awards"
      }
    },
    {
      path: "/privacy-policy",
      name: "privacy",
      component: Privacy,
      meta: {
        title: "privacy"
      }
    },
    {
      path: '/grants',
    },
    {
      path: "/grants/bps",
      name: "bps",
      component: BPS,
      meta: {
        title: "bps"
      }
    },
    {
      path: "/grants/afms",
      name: "afms",
      component: AFMS,
      meta: {
        title: "afms"
      }
    },
    {
      path: "/grants/bridgealfa",
      name: "bridgealfa",
      component: BridgeAlfa,
      meta: {
        title: "bridgealfa"
      }
    },
    {
      path: "/grants/pmt",
      name: "pmt",
      component: PMT,
      meta: {
        title: "pmt"
      }
    },
    {
      path: "/grants/eic",
      name: "eic",
      component: EIC,
      meta: {
        title: "eic"
      }
    },
    {
      path: "/grants/bps2",
      name: "bps2",
      component: BPS2,
      meta: {
        title: "bps2"
      }
    },
    {
      path: "/grants/pbe",
      name: "pbe",
      component: PBE,
      meta: {
        title: "pbe"
      }
    },
    {
      path: "/grants/pbe2",
      name: "pbe2",
      component: PBE2,
      meta: {
        title: "pbe2"
      }
    },
    {
      path: "/grants/ppbb",
      name: "ppbb",
      component: PPBB,
      meta: {
        title: "ppbb"
      }
    },
    {
      path: "/grants/offshore",
      name: "offshore",
      component: Offshore,
      meta: {
        title: "offshore"
      }
    },
    {
      path: "/blog",
      name: "blog",
      component: Blog,
      meta: {
        title: "blog"
      }
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact,
      meta: {
        title: "contact"
      }
    },
    {
      path: "/projects",
      name: "projects",
      component: CofinancedFromEU,
      meta: {
        title: "projects"
      }
    },
    {
      path: "/auctions",
      name: "auctions",
      component: Auctions,
      meta: {
        title: "auctions"
      }
    },
    {
      path: "/infonews",
      name: "infonews",
      component: Infonews,
      meta: {
        title: "infonews"
      }
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
router.beforeEach((to, from, next) => {
  const title = lang[store.state.lang]["page_titles"][to.meta.title];
  document.title = title ? title : document.title;
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js